import riot from 'riot';
import events from '../src/events.js';
import { putDevice as libPutDevice, openSensorSetupGuide } from '../src/lib.js';
riot.tag2('sensor', '<div class="card" style="display:flex; flex-direction:column; height:100%;"> <div class="card-content"> <div class="media"> <div class="media-left"> <figure class="image is-48x48"> <img riot-src="img/{opts.sensor.image}" alt="{opts.sensor.name} Icon"> </figure> </div> <div class="media-content"> <p class="title is-5">{opts.sensor.display_name}</p> <p class="subtitle is-6">{opts.sensor.measures}</p> </div> </div> <div class="buttons"> <button class="button is-warning is-light is-small is-fullwidth" onclick="{showSetupInfo}" title="View Setup Guide"> <span class="icon is-small"> <i class="fas fa-info-circle"></i> </span> <span>Setup Guide</span> </button> </div> <div class="content"> <article class="message" style="cursor:pointer;"> <div class="message-body" onclick="{toggleDescriptionClick}"> {showDescription[opts.sensor.name]?opts.sensor.description:⁗What is the ⁗+opts.sensor.display_name+⁗?⁗} </div> </article> <article class="message" style="cursor:pointer;"> <div class="message-body" onclick="{toggleUseCasesClick}"> {showUseCases[opts.sensor.name]?opts.sensor.used_by:⁗What are some things the ⁗+opts.sensor.display_name+⁗ is used for in real life?⁗} </div> </article> <article class="message" if="{opts.device}"> <div class="message-header"> <p>Pin Configurations</p> </div> <div class="message-body" if="{saving_device_configs}"> <div class="container is-fluid has-text-centered" style="margin-top: 5px;"> <progress class="progress is-large" max="100">60%</progress> </div> </div> <div class="message-body" if="{!saving_device_configs}"> <p>The {opts.sensor.display_name} requires us to use {opts.sensor.default_pins.length} pins. If the pin is configurable, you can change the default setup below! Remember! The raw pin numbers are referring to their position on the board! Please see <a target="_blank" href="https://pinout.xyz/pinout/io_pi_zero">this Pi pinout</a> for more!</p> <div class="field" each="{pin,i in opts.sensor.default_pins}"> <label class="label">{pin.type.charAt(0).toUpperCase()+ pin.type.slice(1)}:</label> <div class="field" if="{pin.configurable}"> <div class="control"> <div class="select is-fullwidth"> <select id="{opts.sensor.name}_pin{i}_select" onchange="{changeColorSelect}"> <option>Blue ({pin.type==⁗analog⁗?⁗A3⁗:⁗D3⁗})</option> <option>Yellow ({pin.type==⁗analog⁗?⁗A2⁗:⁗D2⁗})</option> <option>Green ({pin.type==⁗analog⁗?⁗A1⁗:⁗D1⁗})</option> <option>White ({pin.type==⁗analog⁗?⁗A0⁗:⁗D0⁗})</option> <option>Custom</option> </select> </div> </div> </div> <div class="field" if="{pin.type==⁗digital⁗ && pin.configurable}"> <div class="control"> <input class="input" id="{opts.sensor.name}_pin{i}_input" name="pin number" min="1" max="40" type="number"> </div> </div> <div class="field" if="{pin.type==⁗digital⁗ && !pin.configurable}"> <div class="control"> <input class="input" id="{opts.sensor.name}_pin{i}_input" name="pin number" min="1" max="40" readonly type="number"> </div> </div> </div> </div> </article> <article class="message" if="{!opts.device}" onclick="{routeToDeviceConfig}" style="cursor:pointer;"> <div class="message-body" if="{!saving_device_configs}"> <p>The {opts.sensor.display_name} requires us to use {opts.sensor.default_pins.length} pins. To change the configuration please visit the kit configuration page!</p> </div> </article> <div class="field is-grouped is-grouped-right" if="{opts.device}"> <p class="control"> <a class="button is-success" onclick="{updateSensorConfigClick}"> Update </a> </p> <p class="control"> <a class="button is-light"> Reset </a> </p> </div> </div> </div> </div>', '', '', function(opts) {
        var self = this;
        self.showDescription = {};
        self.showUseCases = {};
        self.selectedDevice = undefined;
        self.selectedSensor = undefined;
        self.saving_device_configs = false;

        self.digitalPinColorNumberMap = {
            "Blue": 31,
            "Yellow": 29,
            "Green": 15,
            "White": 7
        }

        self.on('mount', function() {

            if (self.opts.device) {
                self.selectedDevice = self.opts.device;
                self.selectedSensor = self.opts.sensor;
                self.setupPinConfigurationsComponents();
            }
        });

        events.on('sensor_config_updated', function(sensor_configs) {

            pin_configurations = sensor_configs[self.selectedSensor.name]
            console.log(self.selectedSensor.name);

            for (var j = 0; j < pin_configurations.length; j++) {

                if (pin_configurations[j].configurable) {
                    pin_select = document.getElementById(self.selectedSensor.name + "_pin" + j + "_select");
                    if(pin_select == null) {
                        console.log("Pin select element not found");
                    } else {
                        pin_select.value = self.getPinSelectValueBasedOnColor(pin_configurations[j]);
                        console.log("set inputs " + self.selectedSensor.name + "_pin" + j + "_select = " + pin_select.value);
                    }
                }

                if (pin_configurations[j].type == "digital") {
                    pin_number_input = document.getElementById(self.selectedSensor.name + "_pin" + j + "_input");
                    pin_number_input.value = pin_configurations[j].board_number;
                    console.log("set number inputs " + self.selectedSensor.name + "_pin" + j + "_input = " + pin_number_input.value);
                }
            }

            self.update();
        });

        this.setupPinConfigurationsComponents = function(){
            pin_configurations = self.getInitialPinConfigurations();
            for (var j = 0; j < pin_configurations.length; j++) {

                if (pin_configurations[j].configurable) {
                    pin_select = document.getElementById(self.selectedSensor.name + "_pin" + j + "_select");
                    pin_select.value = self.getPinSelectValueBasedOnColor(pin_configurations[j]);
                }

                if (pin_configurations[j].type == "digital") {
                    pin_number_input = document.getElementById(self.selectedSensor.name + "_pin" + j + "_input");
                    pin_number_input.value = pin_configurations[j].board_number;
                }
            }
        }.bind(this)

        this.routeToDeviceConfig = function(e) {

            route("devices/" + self.selectedDevice.device_id)
        }.bind(this)

        this.showSetupInfo = function(e) {
            openSensorSetupGuide(self.selectedSensor.name);
        }.bind(this)

        this.pinOptionsMappings = function(type, val) {

            D0 = ["D0", "GPIO4", "white", "7", "White (D0)"]
            D1 = ["D1", "GPIO22", "green", "15", "Green (D1)"]
            D2 = ["D2", "GPIO5", "yellow", "29", "Yellow (D2)"]
            D3 = ["D3", "GPIO6", "blue", "31", "Blue (D3)"]

            A0 = ["A0", "AIN0", "white", "0", "White (A0)"]
            A1 = ["A1", "AIN1", "green", "1", "Green (A1)"]
            A2 = ["A2", "AIN2", "yellow", "2", "Yellow (A2)"]
            A3 = ["A3", "AIN3", "blue", "3", "Blue (A3)"]

            if (type == "digital") {
                if (D0.includes(val)) {
                    return D0
                } else if (D1.includes(val)) {
                    return D1
                } else if (D2.includes(val)) {
                    return D2
                } else if (D3.includes(val)) {
                    return D3
                } else {
                    return undefined
                }
            } else {
                if (A0.includes(val)) {
                    return A0
                } else if (A1.includes(val)) {
                    return A1
                } else if (A2.includes(val)) {
                    return A2
                } else if (A3.includes(val)) {
                    return A3
                } else {
                    return undefined
                }
            }
        }.bind(this)

        this.getInitialPinConfigurations = function() {
            var pin_configurations = [];

            if (self.selectedDevice && self.selectedDevice.sensor_configs && self.selectedDevice.sensor_configs[self.selectedSensor.name]) {
                pin_configurations = self.selectedDevice.sensor_configs[self.selectedSensor.name]
            } else {
                pin_configurations = self.selectedSensor.default_pins
            }

            return pin_configurations
        }.bind(this)

        this.get_gpio_from_board_number = function(board_number) {
            board_to_gpio_map = {
                "3": "GPIO2",
                "5": "GPIO3",
                "7": "GPIO4",
                "11": "GPIO17",
                "13": "GPIO27",
                "15": "GPIO22",
                "19": "GPIO10",
                "21": "GPIO9",
                "23": "GPIO11",
                "29": "GPIO5",
                "31": "GPIO6",
                "33": "GPIO13",
                "35": "GPIO19",
                "37": "GPIO26",
                "8": "GPIO14",
                "10": "GPIO15",
                "12": "GPIO18",
                "16": "GPIO23",
                "18": "GPIO24",
                "22": "GPIO25",
                "24": "GPIO8",
                "26": "GPIO7"
            }

            return board_to_gpio_map[board_number];
        }.bind(this)

        this.getPinSelectValueBasedOnColor = function(pin) {
            colorMap = {
                "blue": "3",
                "yellow": "2",
                "green": "1",
                "white": "0"
            }

            pin_mapping = self.pinOptionsMappings(pin.type, pin.board_number)
            if (pin_mapping) {
                var selectString = pin.color.charAt(0).toUpperCase() + pin.color.slice(1) + " (" + (pin.type == "analog" ? "A" : "D") + colorMap[pin.color] + ")";
                return selectString;
            } else {

                return "Custom"
            }
        }.bind(this)

        this.toggleDescriptionClick = function(e) {
            self.showDescription[self.selectedSensor.name] = !self.showDescription[self.selectedSensor.name];
            self.update();
        }.bind(this)

        this.toggleUseCasesClick = function(e) {
            self.showUseCases[self.selectedSensor.name] = !self.showUseCases[self.selectedSensor.name];
            self.update();
        }.bind(this)

        this.changeColorSelect = function(e) {
            selectedColor = document.getElementById(e.srcElement.id).value.split(' ')[0];

            if (e.item.pin.type == "digital") {
                document.getElementById(e.srcElement.id.replace('select', 'input')).value = self.digitalPinColorNumberMap[selectedColor];
            }

        }.bind(this)

        this.updateSensorConfigClick = function(e) {

            config_data = {
                "name": self.selectedDevice.device_name,
                "device": self.selectedDevice.device_id
            };

            sensor_configs = self.selectedDevice.sensor_configs;

            pin_configurations = self.getInitialPinConfigurations();

            for (var j = 0; j < pin_configurations.length; j++) {

                if (pin_configurations[j].configurable) {

                    if (pin_configurations[j].type == "digital") {
                        pin_input = document.getElementById(self.selectedSensor.name + "_pin" + j + "_input");
                        pin_map = self.pinOptionsMappings(pin_configurations[j].type, pin_input.value);
                        if (pin_map) {
                            pin_configurations[j].kit_number = pin_map[0]
                            pin_configurations[j].gpio_number = pin_map[1]
                            pin_configurations[j].color = pin_map[2]
                            pin_configurations[j].board_number = pin_map[3]
                        } else {

                            pin_configurations[j].kit_number = "None"
                            pin_configurations[j].gpio_number = self.get_gpio_from_board_number(pin_input.value)
                            pin_configurations[j].color = "Custom"
                            pin_configurations[j].board_number = pin_input.value
                        }
                    } else {

                        pin_select = document.getElementById(self.selectedSensor.name + "_pin" + j + "_select");
                        pin_map = self.pinOptionsMappings(pin_configurations[j].type, pin_select.value);
                        pin_configurations[j].kit_number = pin_map[0]
                        pin_configurations[j].gpio_number = pin_map[1]
                        pin_configurations[j].color = pin_map[2]
                        pin_configurations[j].board_number = pin_map[3]
                    }

                }

            }

            if (!sensor_configs) {
                sensor_configs = {}
            }
            if (!sensor_configs[self.selectedSensor.name]) {
                sensor_configs[self.selectedSensor.name] = []
            }
            sensor_configs[self.selectedSensor.name] = pin_configurations
            config_data["sensor_configs"] = sensor_configs

            putDevice(config_data);
        }.bind(this)

        function putDevice(data) {
            self.saving_device_configs = true;
            libPutDevice(data).then(function(res) {
                self.update({
                    saving_device_configs: false
                });

                events.emit('sensor_config_updated', res['data']['smartkits'][0]['sensor_configs']);
            }).catch(function(error) {
                console.error('PUT Device Error:' + error);
                self.update({
                    saving_device_configs: false
                });
            });
        }
});
